import React from "react";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { usePermissions } from "../../hooks/usePermissions";
import type { BillAllocationTab } from "../../utils/billAllocationScreenConfig";

interface BillAllocationTabsProps {
  activeTab: BillAllocationTab;
  onTabChange: (tab: BillAllocationTab) => void;
}

const BillAllocationTabs: React.FC<BillAllocationTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { isDarkMode } = useDarkMode();
  const { hasPermission } = usePermissions();

  const tabs: Array<{
    id: BillAllocationTab;
    label: string;
    visible: boolean;
  }> = [
    {
      id: "customer",
      label: "CUSTOMER",
      visible: hasPermission("187", "View"),
    },
    {
      id: "customer_ref_settlement",
      label: "CUSTOMER REFERENCE SETTLEMENT",
      visible: hasPermission("186", "View"),
    },
    {
      id: "vendor",
      label: "VENDOR",
      visible: hasPermission("192", "View"),
    },
    {
      id: "vendor_ref_settlement",
      label: "VENDOR REFERENCE SETTLEMENT",
      visible: hasPermission("186", "View"),
    },
  ];

  const visibleTabs = tabs.filter((tab) => tab.visible);
  if (visibleTabs.length === 0) {
    return null;
  }

  const tabButtonStyles = (isActive: boolean): React.CSSProperties => ({
    padding: "10px 0",
    backgroundColor: "transparent",
    border: "none",
    borderBottom: isActive ? "2px solid #34D399" : "2px solid transparent",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0.04em",
    color: isActive
      ? isDarkMode
        ? "#f1f5f9"
        : "#0F172A"
      : isDarkMode
        ? "#94a3b8"
        : "#64748B",
    marginRight: "20px",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
  });

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        overflowX: "auto",
        borderBottom: isDarkMode ? "1px solid #334155" : "1px solid #E5E7EB",
        padding: "0 4px",
        marginBottom: "12px",
      }}
    >
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          style={tabButtonStyles(activeTab === tab.id)}
          onClick={() => onTabChange(tab.id)}
          aria-selected={activeTab === tab.id}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default BillAllocationTabs;
